import React, { FunctionComponent } from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

import {
  FooterRoot,
  Copyright,
  SocialLinks,
  SocialLink,
  SocialLinkImage,
} from './Footer.style';
import facebookIcon from '../../assets/social/facebook-icon.svg';
import instagramIcon from '../../assets/social/instagram-icon.svg';
import { Logo } from '../Logo';
import { colours } from '../../style/variables';

const Footer: FunctionComponent = () => (
  <FooterRoot>
    <OutboundLink href="https://helfy.uk" aria-label="Helfy">
      <Logo kind="wordmark" width={108} fill={colours.white} title="Helfy" />
    </OutboundLink>
    <Copyright>© {new Date().getFullYear()} Health & Wellness Ltd</Copyright>
    <SocialLinks>
      <SocialLink href="https://www.instagram.com/helfy.uk/">
        <SocialLinkImage src={instagramIcon} alt="Instagram logo" />
      </SocialLink>
      <SocialLink href="https://www.facebook.com/helfy.uk">
        <SocialLinkImage src={facebookIcon} alt="Facebook logo" />
      </SocialLink>
    </SocialLinks>
  </FooterRoot>
);

export default Footer;
